export default __webpack_public_path__ + "static/1675-484b3cc2ab15a7fd5205b012ed55b7e0.gif";